"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxActions = require("redux-actions");

var _reactIntercom = require("react-intercom");

var _httpActions = require("../actions/http-actions");

var _util = require("./util");

var _ajax = require("../actions/ajax");

var _identityActions = require("../actions/identity-actions");

var _handleActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function cacheAuthorizationHeader(jwt) {
  if (jwt) {
    _ajax.axios.defaults.headers.common.Authorization = jwt;
  } else {
    delete _ajax.axios.defaults.headers.common.Authorization;
  }
}

var initialState = {
  jwt: '',
  coDeeder: false,
  identity: {
    uuid: '',
    twoFactorEnabled: false,
    aliases: [// { uuid, value, type, auth, verified }
    ],
    totpVerified: false,
    sms2faVerified: false,
    default2fa: '',
    type: ''
  },
  magicLink: {
    token: '',
    redeemEndPoint: ''
  },
  twoFactorOptions: {
    totpEnabled: false,
    totpVerified: false,
    default2fa: '',
    securityQuestions: undefined,
    loginUuid: '',
    aliases: [// { uuid, value, type, auth, verified }
    ],
    requested: false
  },
  loading: false,
  error: ''
};
exports.initialState = initialState;
var reducer = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, "".concat(_identityActions.GET_IDENTITY, "_").concat(_httpActions.REQUEST), function _() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true,
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_identityActions.REGISTER, "_").concat(_httpActions.REQUEST), "".concat(_identityActions.LO_REGISTRATION, "_").concat(_httpActions.REQUEST), "".concat(_identityActions.LOGIN, "_").concat(_httpActions.REQUEST), "".concat(_identityActions.CO_DEED_LOGIN, "_").concat(_httpActions.REQUEST), "".concat(_identityActions.MAGICLINK_LOGIN, "_").concat(_httpActions.REQUEST), "".concat(_identityActions.MAGICLINK_AUTO_LOGIN, "_").concat(_httpActions.REQUEST), "".concat(_identityActions.MAGICLINK_REDEEM, "_").concat(_httpActions.REQUEST), "".concat(_identityActions.TOGGLE_2FA, "_").concat(_httpActions.REQUEST), "".concat(_identityActions.UPDATE_PASSWORD, "_").concat(_httpActions.REQUEST), "".concat(_identityActions.TOKEN_REQUEST_2FA, "_").concat(_httpActions.REQUEST), "".concat(_identityActions.TOKEN_REDEEM_2FA, "_").concat(_httpActions.REQUEST), "".concat(_identityActions.VERIFY_REQUEST, "_").concat(_httpActions.REQUEST), "".concat(_identityActions.VERIFY_ALIAS, "_").concat(_httpActions.REQUEST), "".concat(_identityActions.ADD_ALIAS, "_").concat(_httpActions.REQUEST), "".concat(_identityActions.REVOKE_ALIAS, "_").concat(_httpActions.REQUEST), "".concat(_identityActions.LINK_PROVENANCE_OAUTH_PROVIDER, "_").concat(_httpActions.REQUEST), "".concat(_identityActions.UNLINK_PROVENANCE_OAUTH_PROVIDER, "_").concat(_httpActions.REQUEST), "".concat(_identityActions.REDEEM_TOTP, "_").concat(_httpActions.REQUEST), "".concat(_identityActions.VERIFY_TOTP, "_").concat(_httpActions.REQUEST), "".concat(_identityActions.GET_TOTP_URL, "_").concat(_httpActions.REQUEST)), function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread(_objectSpread({}, state), {}, {
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_identityActions.GET_IDENTITY, "_").concat(_httpActions.FAILURE), "".concat(_identityActions.REGISTER, "_").concat(_httpActions.FAILURE), "".concat(_identityActions.LO_REGISTRATION, "+").concat(_httpActions.FAILURE), "".concat(_identityActions.LOGIN, "_").concat(_httpActions.FAILURE), "".concat(_identityActions.CO_DEED_LOGIN, "_").concat(_httpActions.FAILURE), "".concat(_identityActions.MAGICLINK_LOGIN, "_").concat(_httpActions.FAILURE), "".concat(_identityActions.MAGICLINK_AUTO_LOGIN, "_").concat(_httpActions.FAILURE), "".concat(_identityActions.MAGICLINK_REDEEM, "_").concat(_httpActions.FAILURE), "".concat(_identityActions.TOGGLE_2FA, "_").concat(_httpActions.FAILURE), "".concat(_identityActions.UPDATE_PASSWORD, "_").concat(_httpActions.FAILURE), "".concat(_identityActions.TOKEN_REQUEST_2FA, "_").concat(_httpActions.FAILURE), // `${TOKEN_REDEEM_2FA}_${FAILURE}` is overridden
"".concat(_identityActions.VERIFY_REQUEST, "_").concat(_httpActions.FAILURE), "".concat(_identityActions.VERIFY_ALIAS, "_").concat(_httpActions.FAILURE), "".concat(_identityActions.ADD_ALIAS, "_").concat(_httpActions.FAILURE), "".concat(_identityActions.REVOKE_ALIAS, "_").concat(_httpActions.FAILURE), "".concat(_identityActions.LINK_PROVENANCE_OAUTH_PROVIDER, "_").concat(_httpActions.FAILURE), "".concat(_identityActions.UNLINK_PROVENANCE_OAUTH_PROVIDER, "_").concat(_httpActions.FAILURE), "".concat(_identityActions.REDEEM_TOTP, "_").concat(_httpActions.FAILURE), "".concat(_identityActions.VERIFY_TOTP, "_").concat(_httpActions.FAILURE), "".concat(_identityActions.GET_TOTP_URL, "_").concat(_httpActions.FAILURE)), function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    error: (0, _util.payloadError)(action)
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_identityActions.GET_IDENTITY, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var phoneNumberAliases = action.payload.aliases ? action.payload.aliases.filter(function (_ref) {
    var type = _ref.type,
        verified = _ref.verified;
    return type === 'Phone' && verified;
  }) : [];
  return _objectSpread(_objectSpread({}, state), {}, {
    identity: _objectSpread(_objectSpread({}, state.identity), {}, {
      uuid: action.payload.uuid,
      twoFactorEnabled: action.payload.twoFactorEnabled,
      aliases: (0, _util.mergeList)(state.identity.aliases, action.payload.aliases),
      passwordExpired: action.payload.passwordExpired,
      default2fa: action.payload.default2fa,
      totpVerified: action.payload.totpVerified,
      sms2faVerified: phoneNumberAliases.length !== 0,
      type: action.payload.type
    }),
    loading: false
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_identityActions.LO_REGISTRATION, "_").concat(_httpActions.SUCCESS), "".concat(_identityActions.REGISTER, "_").concat(_httpActions.SUCCESS)), function (state, action) {
  cacheAuthorizationHeader(action.payload.jwt);
  return _objectSpread(_objectSpread({}, state), {}, {
    jwt: action.payload.jwt || ''
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_identityActions.LOGIN, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  cacheAuthorizationHeader(action.payload.jwt);
  var _action$payload$twoFa = action.payload.twoFactorOptions,
      twoFactorOptions = _action$payload$twoFa === void 0 ? _objectSpread({}, initialState.twoFactorOptions) : _action$payload$twoFa;
  return _objectSpread(_objectSpread({}, state), {}, {
    jwt: action.payload.jwt || '',
    twoFactorOptions: _objectSpread(_objectSpread({}, twoFactorOptions), {}, {
      aliases: (0, _toConsumableArray2.default)(twoFactorOptions.aliases.filter(function (a) {
        return a.type.toUpperCase() === 'PHONE';
      })),
      requested: false
    })
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_identityActions.CO_DEED_LOGIN, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  cacheAuthorizationHeader(action.payload.jwt);
  return _objectSpread(_objectSpread({}, state), {}, {
    jwt: action.payload.jwt,
    coDeeder: true
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_identityActions.MAGICLINK_LOGIN, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  cacheAuthorizationHeader(action.payload.jwtToken); // does this ever return a value?

  return _objectSpread(_objectSpread({}, state), {}, {
    jwt: action.payload.jwtToken || '',
    magicLink: _objectSpread(_objectSpread({}, state.magicLink), {}, {
      token: action.payload.magicLinkToken,
      redeemEndPoint: action.payload.redeemEndPoint
    })
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_identityActions.VERIFY_SECURITY_QUESTION, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  cacheAuthorizationHeader(action.payload.jwt);
  return _objectSpread(_objectSpread({}, state), {}, {
    jwt: action.payload.jwt
  });
}), (0, _defineProperty2.default)(_handleActions, _identityActions.MAGICLINK_RESET, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    magicLink: {
      token: '',
      // clear it from cache most likely set to LocalStorage
      redeemEndPoint: ''
    }
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_identityActions.MAGICLINK_REDEEM, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  cacheAuthorizationHeader(action.payload.jwt);
  var twoFactorOptions = action.payload.twoFactorOptions;
  var isTwoFactor = twoFactorOptions !== null && (0, _typeof2.default)(twoFactorOptions) === 'object';
  return _objectSpread(_objectSpread({}, state), {}, {
    jwt: action.payload.jwt || '',
    twoFactorOptions: _objectSpread(_objectSpread({}, state.twoFactorOptions), {}, {
      loginUuid: isTwoFactor ? twoFactorOptions.loginUuid : '',
      // TODO: this only handles one alias per type, if we support multiple will need to change how we merge
      aliases: isTwoFactor ? (0, _util.mergeList)(state.twoFactorOptions.aliases, twoFactorOptions.aliases) : [],
      requested: false
    })
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_identityActions.TOKEN_REQUEST_2FA, "_").concat(_httpActions.SUCCESS), function _() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread(_objectSpread({}, state), {}, {
    twoFactorOptions: _objectSpread(_objectSpread({}, state.twoFactorOptions), {}, {
      requested: true
    }),
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_identityActions.TOKEN_REDEEM_2FA, "_").concat(_httpActions.SUCCESS), "".concat(_identityActions.REDEEM_TOTP, "_").concat(_httpActions.SUCCESS)), function (state, action) {
  cacheAuthorizationHeader(action.payload.jwt);
  return _objectSpread(_objectSpread({}, state), {}, {
    jwt: action.payload.jwt || '',
    twoFactorOptions: _objectSpread({}, initialState.twoFactorOptions)
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_identityActions.TOKEN_REDEEM_2FA, "_").concat(_httpActions.FAILURE), "".concat(_identityActions.REDEEM_TOTP, "_").concat(_httpActions.FAILURE)), function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    twoFactorOptions: _objectSpread(_objectSpread({}, state.twoFactorOptions), {}, {
      requested: false
    }),
    error: (0, _util.payloadError)(action)
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)(_identityActions.LOGOUT, _identityActions.TIMEOUT), function () {
  cacheAuthorizationHeader(null);
  (0, _reactIntercom.IntercomAPI)('shutdown');
  return _objectSpread({}, initialState);
}), (0, _defineProperty2.default)(_handleActions, _identityActions.RELOAD, function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  cacheAuthorizationHeader(state.jwt);
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false,
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, _identityActions.ROTATE_JWT, function (state, action) {
  cacheAuthorizationHeader(action.payload.jwt);
  return _objectSpread(_objectSpread({}, state), {}, {
    jwt: action.payload.jwt
  });
}), (0, _defineProperty2.default)(_handleActions, _httpActions.HTTP_CANCEL_ALL, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false,
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_identityActions.GET_SECURITY_QUESTIONS, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    twoFactorOptions: _objectSpread(_objectSpread({}, state.twoFactorOptions), {}, {
      securityQuestions: action.payload
    })
  });
}), _handleActions), initialState);
var _default = reducer;
exports.default = _default;